/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Salary_Negotiate_Target_SalaryInputs */

const en_salary_negotiate_target_salary = /** @type {(inputs: Salary_Negotiate_Target_SalaryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Target Salary`)
};

const de_salary_negotiate_target_salary = /** @type {(inputs: Salary_Negotiate_Target_SalaryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Zielgehalt`)
};

const fr_salary_negotiate_target_salary = /** @type {(inputs: Salary_Negotiate_Target_SalaryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Salaire cible`)
};

const es_salary_negotiate_target_salary = /** @type {(inputs: Salary_Negotiate_Target_SalaryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Salario objetivo`)
};

const it_salary_negotiate_target_salary = /** @type {(inputs: Salary_Negotiate_Target_SalaryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Stipendio desiderato`)
};

const nl_salary_negotiate_target_salary = /** @type {(inputs: Salary_Negotiate_Target_SalaryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gewenst salaris`)
};

const pl_salary_negotiate_target_salary = /** @type {(inputs: Salary_Negotiate_Target_SalaryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Docelowe wynagrodzenie`)
};

const fi_salary_negotiate_target_salary = /** @type {(inputs: Salary_Negotiate_Target_SalaryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tavoitepalkka`)
};

const da_salary_negotiate_target_salary = /** @type {(inputs: Salary_Negotiate_Target_SalaryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Målløn`)
};

const sv_salary_negotiate_target_salary = /** @type {(inputs: Salary_Negotiate_Target_SalaryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mållön`)
};

/**
* | output |
* | --- |
* | "Target Salary" |
*
* @param {Salary_Negotiate_Target_SalaryInputs} inputs
* @param {{ locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }} options
* @returns {LocalizedString}
*/
export const salary_negotiate_target_salary = /** @type {((inputs?: Salary_Negotiate_Target_SalaryInputs, options?: { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Salary_Negotiate_Target_SalaryInputs, { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_salary_negotiate_target_salary(inputs)
	if (locale === "fr") return fr_salary_negotiate_target_salary(inputs)
	if (locale === "es") return es_salary_negotiate_target_salary(inputs)
	if (locale === "it") return it_salary_negotiate_target_salary(inputs)
	if (locale === "nl") return nl_salary_negotiate_target_salary(inputs)
	if (locale === "pl") return pl_salary_negotiate_target_salary(inputs)
	if (locale === "fi") return fi_salary_negotiate_target_salary(inputs)
	if (locale === "da") return da_salary_negotiate_target_salary(inputs)
	if (locale === "sv") return sv_salary_negotiate_target_salary(inputs)
	return en_salary_negotiate_target_salary(inputs)
});